export default __webpack_public_path__ + "static/media/danya.2e924623.txt";